const socialPracticeScore = [{
  path: 'socialPracticeScore/index',
  component: resolve => require(['../../../../components/pages/studentresults/socialPracticeScore'], resolve)
}]
export default socialPracticeScore
